import React from 'react'

export const ArrowDownLarge = props => (
  <svg
    width={16}
    height={20}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071L0.292893 12.7071C-0.097632 12.3166 -0.097632 11.6834 0.292893 11.2929C0.683417 10.9024 1.31658 10.9024 1.70711 11.2929L7 16.5858L7 1C7 0.447715 7.44772 -3.73832e-07 8 -3.49691e-07C8.55228 -3.2555e-07 9 0.447715 9 1L9 16.5858L14.2929 11.2929C14.6834 10.9024 15.3166 10.9024 15.7071 11.2929Z'
    />
  </svg>
)

